import { useQuery } from 'react-query';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

import type { CustomTextEntityList } from 'views/App/Portal/Policy/_types/customTextEntities';

export async function getCustomTextEntities(manualId: string, signal?: AbortSignal): Promise<CustomTextEntityList> {
  return fetcher({
    method: 'GET',
    url: `${baseApiUrl()}/lexiverse/text-entity/v1/manuals/${manualId}/text-entities/custom`,
    options: { signal },
  });
}

export default function useCustomTextEntities(
  manualId: string,
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<CustomTextEntityList, ServerErrorResponse>(
    ['customTextEntities', manualId],
    async ({ signal }): Promise<CustomTextEntityList> => {
      try {
        return await getCustomTextEntities(manualId, signal);
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      ...options,
      enabled: !!manualId,
    }
  );
}
